import React from 'react';
import SoundBand from './SoundBand';
import './FavoritesPage.css';

const FavoritesPage = ({ favorites, removeFromFavorites, isFavorite, currentlyPlayingId, onPlay }) => {
  if (favorites.length === 0) {
    return (
      <div className="favorites-page">
        <div className="favorites-header">
          <h1>Mes Favoris</h1>
          <p>Vos sons préférés sont sauvegardés ici</p>
        </div>
        
        <div className="favorites-empty">
          <div className="empty-state">
            <span className="empty-icon">💔</span>
            <h3>Aucun favori pour le moment</h3>
            <p>Ajoutez des sons à vos favoris en cliquant sur le cœur ❤️</p>
            <p>Ils seront automatiquement sauvegardés dans votre navigateur.</p>
          </div>
        </div>
      </div>
    );
  }

  // Trier les favoris par date d'ajout (plus récent en premier)
  const sortedFavorites = [...favorites].sort((a, b) => {
    return new Date(b.addedAt) - new Date(a.addedAt);
  });

  return (
    <div className="favorites-page">
      <div className="favorites-header">
        <h1>Mes Favoris</h1>
        <p>{favorites.length} son{favorites.length > 1 ? 's' : ''} en favori{favorites.length > 1 ? 's' : ''}</p>
      </div>

      <div className="favorites-grid">
        {sortedFavorites.map(sound => (
          <div key={sound.id} className="favorite-item">
            <SoundBand
              sound={sound}
              isFavorite={isFavorite(sound.id)}
              onToggleFavorite={() => removeFromFavorites(sound.id)}
              isPlaying={currentlyPlayingId === sound.id}
              onPlay={() => onPlay(sound)}
            />
            <div className="favorite-date">
              Ajouté le {new Date(sound.addedAt).toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FavoritesPage;
